import { MembersSelect } from "@/components/molecules/members-select";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useTranslation } from "@/features/utils/i18n";

interface TimeOffFormProps {
  reason: string;
  startDate: string;
  endDate: string;
  affectedMemberIds: string[];
  onReasonChange: (value: string) => void;
  onStartDateChange: (value: string) => void;
  onEndDateChange: (value: string) => void;
  onAffectedMembersChange: (value: string[]) => void;
  onSubmit: (e: React.FormEvent) => void;
  onCancel: () => void;
  submitLabel: string;
  isSubmitting: boolean;
}

export const TimeOffForm = ({
  reason,
  startDate,
  endDate,
  affectedMemberIds,
  onReasonChange,
  onStartDateChange,
  onEndDateChange,
  onAffectedMembersChange,
  onSubmit,
  onCancel,
  submitLabel,
  isSubmitting,
}: TimeOffFormProps) => {
  const { t } = useTranslation("schedules");
  return (
    <form onSubmit={onSubmit} className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="reason">{t("closures.form.reason")}</Label>
        <Input
          id="reason"
          value={reason}
          onChange={(e) => onReasonChange(e.target.value)}
          placeholder={t("closures.form.reasonPlaceholder")}
        />
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="start_date">{t("closures.form.startDate")} *</Label>
          <Input
            id="start_date"
            type="date"
            value={startDate}
            onChange={(e) => onStartDateChange(e.target.value)}
            required
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="end_date">{t("closures.form.endDate")} *</Label>
          <Input
            id="end_date"
            type="date"
            value={endDate}
            onChange={(e) => onEndDateChange(e.target.value)}
            required
          />
        </div>
      </div>

      <div className="space-y-2">
        <Label htmlFor="affected_members">
          {t("closures.form.affectedMembers")}
        </Label>
        <MembersSelect
          value={affectedMemberIds}
          onChange={onAffectedMembersChange}
          allowAll={true}
          multiple={true}
          placeholder={t("closures.form.affectedMembersPlaceholder")}
        />
        <p className="text-xs text-muted-foreground">
          {t("closures.form.affectedMembersHelp")}
        </p>
      </div>

      <div className="flex justify-end gap-2">
        <Button type="button" variant="outline" onClick={onCancel}>
          {t("closures.form.cancel")}
        </Button>
        <Button type="submit" disabled={isSubmitting}>
          {isSubmitting ? t("closures.form.saving") : submitLabel}
        </Button>
      </div>
    </form>
  );
};
